import { createApiReducer } from 'reacticoon/reducer'
import { postLogin } from './actions'

const loginReducer = createApiReducer(postLogin)

export default loginReducer
